import {
  Expression,
  DynamicModel,
  PositionRotationScale,
  ExpressionInput,
} from '@k3/core';
import { ModelAction } from '@k3/core/dist/src/lib/engine/actionEngine2/types';
import {
  DefaultModelProps,
  Model,
} from '@k3/core/dist/src/lib/types/model.interface';
import { Stack } from '@mui/material';

type ReceivedProps = {
  modelAction?: ModelAction;
  intensity: number;
};

type SentProps = {
  intensity: Expression;
};

const PropsDialog: DynamicModel<ReceivedProps, SentProps>['propsDialog'] = (
  props
) => {
  return (
    <Stack direction="column" spacing={4}>
      <PositionRotationScale {...props} />

      <ExpressionInput
        label="Intensität"
        value={props.dynamicModelProps.intensity.expression}
        onChange={(expression) => props.onChange('intensity')({ expression })}
      />
    </Stack>
  );
};

export type AmbientLightDynamicModelProps = ReceivedProps &
  DefaultModelProps &
  Pick<Model, 'id'>;

const AmbientLight = (props: AmbientLightDynamicModelProps) => {
  return (
    <ambientLight
      position={props.position}
      intensity={props.intensity}
      userData={{ modelId: props.id }}
    />
  );
};

export const ambientLight: DynamicModel<ReceivedProps, SentProps> = {
  type: 'ambientLight',
  label: 'AmbientLight',
  disabledForAR: false,
  component: AmbientLight,
  propsDialog: PropsDialog,
  defaultProps: {
    intensity: { expression: '1' },
  },
  materials: [],
};
